import AnchorLink from 'anchor-link'
import AnchorLinkBrowserTransport from 'anchor-link-browser-transport'
import type { EosAccount, EosAction, EosConfig, TransactionResult, WalletAdapter } from '@/types'

export class AnchorWallet implements WalletAdapter {
  private identifier = 'Totoro'
  private transport: AnchorLinkBrowserTransport | null = null
  private link: AnchorLink | null = null
  private session: any = null
  private accounts: EosAccount[] = []

  async connect(config: EosConfig, _rpc: unknown): Promise<EosAccount[]> {
    this.transport = new AnchorLinkBrowserTransport()
    this.link = new AnchorLink({
      transport: this.transport,
      chains: [{ chainId: config.chainId, nodeUrl: config.rpcUrl }],
    } as any)
    this.accounts = []
    this.session = await this.link.restoreSession(this.identifier)
    if (this.session) {
      this.accounts.push({
        name: this.session.auth.actor.toString(),
        authority: this.session.auth.permission.toString(),
      })
    }
    return this.accounts
  }

  async login(): Promise<EosAccount[]> {
    if (!this.link) throw new Error('Not connected')
    const identity = await this.link.login(this.identifier)
    this.session = identity.session
    this.accounts = [{
      name: this.session.auth.actor.toString(),
      authority: this.session.auth.permission.toString(),
    }]
    return this.accounts
  }

  async logout(): Promise<void> {
    if (this.session) {
      await this.session.remove()
    }
  }

  async transact(actions: EosAction[]): Promise<TransactionResult> {
    if (!this.session) throw new Error('Session expired')
    const transaction = await this.session.transact({ actions })
    return transaction as TransactionResult
  }
}
